import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  InputGroup,
  HelpBlock,
  Button,
  Form,
  Col
} from 'react-bootstrap';
import { searchRequest } from 'actions/request';
import { validatePhone } from 'helpers/ValidatorHelper';
import { formatTransactionNumber } from 'helpers/RequestHelper';
import { getUserPrefix } from 'helpers/Users';

class QuickSearch extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false, term: '', notFound: false };
    this.urlPrefix = getUserPrefix(props.user);
  }

  onChange = event => {
    this.setState({ term: event.target.value, notFound: false });
  };

  onClick = () => {
    this.setState({ isLoading: true });
    this.props.searchRequest(this.state.term).then(res => {
      const resData = res.payload.data;
      if (!resData) return null;
      if (resData.data.length) {
        const requestId = res.payload.data.data[0].id;
        const url = `${this.urlPrefix}/requests/${requestId}`;
        this.props.history.push(url);
      } else {
        this.setState({ notFound: true });
      }
    });
  };

  renderHelpBlock = message => {
    return (
      <div style={{ marginTop: 15 }}>
        <HelpBlock bsClass="red">{message}</HelpBlock>
      </div>
    );
  };

  renderValidationMessage = () => {
    const { term, notFound } = this.state;
    const termStr = String(term);
    if (termStr.length && !validatePhone(termStr)) {
      const msg = 'Invalid request id, must be a number.';
      return this.renderHelpBlock(msg);
    }
    if (notFound) {
      const tn = formatTransactionNumber(termStr);
      const msg = `Request CBRSA${tn} not found.`;
      return this.renderHelpBlock(msg);
    }
    return null;
  };

  isFormValid = () => {
    const { term, notFound } = this.state;
    const termStr = String(term);
    return termStr.length > 0 && validatePhone(termStr) && !notFound;
  };

  onFormSubmit = event => {
    // prevent default form submission
    event.preventDefault();

    // validate form and emulate submit button click
    if (this.isFormValid()) {
      this.onClick();
    }
  };

  render() {
    const { user } = this.props;
    const { term } = this.state;

    // available for staff only
    if (!user || (!user.isStaff && !user.isAccountant)) return null;

    const canSubmit = term.length > 0 && validatePhone(term);

    return (
      <div className="text-center">
        <Form horizontal onSubmit={this.onFormSubmit}>
          <FormGroup controlId="quickSearchForm">
            <Col
              componentClass={ControlLabel}
              xs={12}
              sm={5}
              md={5}
              className="text-left"
            >
              Go to Request ID:
            </Col>
            <Col
              xs={12}
              sm={3}
              md={3}
              style={{ width: 300 }}
              id="ctia-textinput"
            >
              <InputGroup>
                <InputGroup.Addon>CBRSA</InputGroup.Addon>
                <FormControl
                  type="text"
                  value={term}
                  onChange={this.onChange}
                />
                <InputGroup.Button>
                  <Button onClick={this.onClick} disabled={!canSubmit}>
                    Go!
                  </Button>
                </InputGroup.Button>
              </InputGroup>
              <FormControl.Feedback />
              {this.renderValidationMessage()}
            </Col>
            <Col xs={12} sm={4} md={4} />
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  { searchRequest }
)(QuickSearch);



// WEBPACK FOOTER //
// ./src/components/QuickSearch.js